import React from 'react';

// Full-cover notice for the remote-view popups (VNC / Moonlight stream).
// Shown when the dashboard's polled device status flips to offline while a
// session is open, so the frozen last frame reads as "device went offline"
// instead of "the stream hung". The parent stops rendering it (and
// reconnects) when the device comes back online.
const DeviceOfflineOverlay = ({ deviceName = 'This device', onClose }) => (
	<div className='absolute inset-0 z-[60] flex items-center justify-center bg-black/70 p-4 font-sans'>
		<div className='bg-slate-900/95 backdrop-blur-xl rounded-2xl shadow-2xl border border-slate-700/50 p-8 max-w-md w-full text-center'>
			<div className='w-14 h-14 rounded-full bg-amber-500/20 flex items-center justify-center mx-auto mb-4'>
				<svg className='w-7 h-7 text-amber-400' fill='none' stroke='currentColor' viewBox='0 0 24 24' strokeWidth={2}>
					<path strokeLinecap='round' strokeLinejoin='round' d='M8.288 15.038a5.25 5.25 0 017.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12 18.75h.008v.008H12v-.008z' />
					<path strokeLinecap='round' strokeLinejoin='round' d='M3.53 2.47l18 18' />
				</svg>
			</div>
			<h3 className='text-lg font-semibold text-white'>Device offline</h3>
			<p className='text-sm text-gray-400 mt-2'>
				{deviceName} is no longer reachable. The session will resume
				automatically once the device is back online.
			</p>
			<div className='flex items-center justify-center gap-2 mt-4 text-xs text-amber-300/90'>
				<span className='w-1.5 h-1.5 rounded-full bg-amber-400 animate-pulse inline-block' />
				Awaiting reconnection…
			</div>
			{onClose && (
				<button
					onClick={onClose}
					className='mt-6 w-full px-4 py-2.5 rounded-lg bg-slate-700/80 hover:bg-slate-600/80 text-gray-200 text-sm font-medium transition-colors'
				>
					Close
				</button>
			)}
		</div>
	</div>
);

export default DeviceOfflineOverlay;
